import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AttachmentFilenameCellRendererParams } from './models/attachment-filename-cell-renderer-params';
import { AttachmentManagementService } from '../../../services/attachment-management/attachment-management.service';
import { AttachmentService } from '../../../services/attachment/attachment.service';
import { tap } from 'rxjs';

@Component({
    selector: 'app-attachment-filename-cell-renderer',
    templateUrl: './attachment-filename-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [],
})
export class AttachmentFilenameCellRendererComponent
    implements ICellRendererAngularComp
{
    params!: AttachmentFilenameCellRendererParams;

    constructor(
        private readonly attachmentService: AttachmentService,
        private readonly attachmentManagementService: AttachmentManagementService,
    ) {}

    agInit(params: AttachmentFilenameCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false;
    }

    /**
     * Downloads the attachment associated with the current cell.
     */
    downloadAttachment(): void {
        const { applicationId, id, filename } = this.params.data;

        this.attachmentService
            .get(applicationId, id)
            .pipe(
                tap((blob) =>
                    this.attachmentManagementService.downloadAttachmentBlob(
                        blob,
                        filename,
                    ),
                ),
            )
            .subscribe();
    }
}
